import cn from 'classnames';
import { IconInfoBubbleToolTip } from '@/components/icons';
import { Tooltip } from '@/components/Tooltip';
// Hooks
import usePropChangeDelay from '@/hooks/usePropChangeDelay';
// CSS
import styles from './error-tip.module.css';

export interface ErrorTipProps {
	testId?: string;
	id: string;
	error?: string;
}

const ErrorTip = (props: ErrorTipProps) => {
	const { testId = 'ErrorTip', error, id } = props;
	const visibleError = usePropChangeDelay(error, 300);
	return (
		<Tooltip id={id} show={!!error}>
			<span
				data-testid={testId}
				className={cn(
					// margin top should match padding to correct alignment
					'mx-auto mt-4 flex max-w-fit items-center gap-1 rounded-lg bg-white py-1 pl-2 pr-3 shadow-md',
					'after:absolute after:left-1/2 after:top-full after:-ml-2 after:h-2 after:w-5 after:bg-white after:content-[""]',
					styles['triangle-down'],
				)}
			>
				<IconInfoBubbleToolTip
					className="h-6 w-6 shrink-0 stroke-pink-600 p-1"
					aria-label=""
					aria-hidden
				/>
				<span className="text-xs text-slate-500">{visibleError}</span>
			</span>
		</Tooltip>
	);
};

export default ErrorTip;
